import { Component, OnInit } from '@angular/core';
import { HttpserviceService } from '../../service/http.service.service';
import { Router } from '@angular/router';
import { UtilsService } from '../../service/utils.service';
import { GlobalConfig } from '../../entities/global-config';
import { BsModalRef } from 'ngx-bootstrap';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-set-agent',
  templateUrl: './set-agent.component.html',
  styleUrls: ['./set-agent.component.css']
})
export class SetAgentComponent implements OnInit {
  src: any = '';
  apiUrl: any = '';
  agentForm: FormGroup;
  formErrors: any;
  submitted: Boolean = false;
  packages: any[] = [];
  bsValue: Date = new Date();
  emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';
  id: any = 0;
  isEdit: Boolean = false;
  agentLogo: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private servicesComponent: HttpserviceService,
    private router: Router,
    private utilsService: UtilsService,
    private config: GlobalConfig,
    private toastr: ToastsManager
  ) {
    this.id = route.snapshot.params['id'];
  }

  agent: any = {
    companyName: '',
    firstName: '',
    lastName: '',
    phone: '',
    about: '',
    officeAddress: '',
    city: '',
    website: '',
    clientOrn: '',
    featured: 0,
    packageId: 0,
    tradeLicienceNo: '',
    licienceExpiry: '',
    billingRef: '',
    base64Icon: '',
    email: '',
    secondEmail:'',
    userName: '',
    password: ''
  };
  ngOnInit() {
    this.apiUrl = this.config.apiRootUrl;
    if (this.id > 0) {
      this.isEdit = true;
      this.getAgentDetail(this.id);
    }
    this.getPackages();
  }

  addAgent(form) {
    this.submitted = false;
    if (form.valid) {
      this.agent.base64Icon = this.src;
      if (this.agent.base64Icon == null || this.agent.base64Icon == "") {
        this.toastr.info('Please select valid file.', 'Info!');
        this.agentLogo = true;
        return;
      }
      this.servicesComponent.saveAgent(this.agent)
        .then((response: any) => {
          if (response.receiveObj.success == true) {
            this.router.navigate(['./agents']);
            this.toastr.success('agent saved successfully.', 'Success!');
          }
          else if (response.receiveObj.success == false) {
            if (response.receiveObj.checkuser.isEmail == true) {
              this.toastr.info('Email is already exist.', 'Info!');
            }
            else if (response.receiveObj.checkuser.isUserName == true) {
              this.toastr.info('User Name is already exist.', 'Info!');
            }
          }
          else if (!response.receiveObj.success && response.receiveObj.duplicateUser) {
            this.toastr.info('This user is already exist.', 'Info!');
          }
        })
        .catch(error => {
          console.log(error);
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        });
    } else {
      this.submitted = true;
    }
  }

  getPackages() {
    this.servicesComponent.getPackages()
      .then((response: any) => {
        if (response.success) {
          this.packages = response.receiveObj;
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });

  }

  onFileChange($event) {
    const image: any = new Image();
    const file: File = $event.target.files[0];
    const extension = this.getFileExtension(file.name);
    if (extension.toLowerCase() === 'png' || extension.toLowerCase() === 'gif' ||
      extension.toLowerCase() === 'jpg' || extension.toLowerCase() === 'svg') {
      const myReader: FileReader = new FileReader();
      const that = this;
      myReader.onloadend = function (loadEvent: any) {
        that.src = loadEvent.target.result;
      };
      this.agentLogo = false;
      myReader.readAsDataURL(file);
    } else {
      this.agentLogo = true;
      this.toastr.info('Please select valid file.', 'Info!');
    }
  }

  getFileExtension(filename) {
    return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
  }

  getAgentDetail(id) {
    this.servicesComponent.getAgentDetail(id)
      .then((response: any) => {
        if (response.success) {
          this.agent = response.receiveObj;
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  updateAgent(form) {
    this.submitted = false;
    this.agent.base64Icon = this.src;
    this.agentLogo = false;
    this.servicesComponent.updateAgent(this.agent)
      .then((response: any) => {
        if (response.receiveObj.success) {
          this.router.navigate(['./agents']);
          this.toastr.success('agent update successfully.', 'Success!');
        } else if (!response.receiveObj.success && response.receiveObj.duplicateUser) {
          this.toastr.info('This user is already exist.', 'Info!');
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });

  }
}



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/code/kapil/DubairentV3/cpapi/CPDubairentApp/CPDubairentApp/src/app/agentManagement/set-agent/set-agent.component.ts